import React, { useContext } from 'react';
import ProductsTable from './ProductsTable';
import { CommonContext } from '../../context/CommonContext';
import { ProductsContext } from '../../context/ProductsContext';
import { Box, Button, CardHeader, Paper } from '@mui/material';
import AlertMessage from '../common/AlertMessage';
import Loader from '../common/Loader';
import AddModal from './AddModal';
import FilterBar from './FilterBar';
import { Add, DownloadOutlined, UploadOutlined } from '@mui/icons-material';
import UploadProductModal from './UploadProductModal';

export default function ProductsScreenView() {
    const { openAlert } = useContext(CommonContext);
    const { isLoading, handleAddModal, onExport, handleUploadModal } = useContext(ProductsContext);
    return (
        <div className='main-screen'>
            {openAlert && <AlertMessage />}
            {isLoading && <Loader />}
            <AddModal />
            <UploadProductModal />
            <Box className="component-header">
                <CardHeader title="Products" />
                <Box className="action-btns-group">
                    <Button variant="outlined" className="action-btn" endIcon={<DownloadOutlined />}
                        onClick={() => onExport()}
                    >
                        Export Product[s]
                    </Button>
                    <Button variant="outlined" className="action-btn" endIcon={<UploadOutlined />}
                        onClick={handleUploadModal}
                    >
                        Upload Product
                    </Button>
                    <Button variant="outlined" className="action-btn" endIcon={<Add />} onClick={handleAddModal}>
                        Add Product
                    </Button>
                </Box>
            </Box>
            <Paper sx={{ boxShadow: 'none' }}>
                <FilterBar />
                <ProductsTable />
            </Paper>
        </div>
    );
}
